import * as React from 'react';
import { useCallback } from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
} from '../../../../../web/components-v2/Dropdown';
import { useOfficeLocationAutocompleteQuery } from '../../../../queries/Aida/useOfficeLocationAutocomplete';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (item: string | null) => void;
	selected?: string | null;
}

export const OfficeLocationSelect: React.FC<IProps> = ({ onChange, selected }) => {
	const { data: officeLocations = [], isPending, isError } = useOfficeLocationAutocompleteQuery();

	const handleSelect = useCallback(
		(value: string) => {
			onChange(value);
		},
		[onChange]
	);

	const handleClear = useCallback(() => {
		onChange(null);
	}, [onChange]);

	const isEmpty = !isPending && !isError && officeLocations.length === 0;
	const triggerLabel = isPending
		? 'Loading offices...'
		: isError
			? 'Error loading offices'
			: isEmpty
				? 'No offices configured'
				: selected
					? `Office: ${selected}`
					: 'Filter by Office';

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[styleSheet.filterDropdownTrigger]} disabled={isPending || isEmpty}>
				{triggerLabel}
			</DropdownSelectTrigger>
			<DropdownContent>
				{!isPending &&
					!isError &&
					officeLocations.map(office => (
						<DropdownItem key={office} onClick={() => handleSelect(office)}>
							{office}
						</DropdownItem>
					))}
				{selected && <DropdownItem onClick={handleClear}>Clear selection</DropdownItem>}
			</DropdownContent>
		</Dropdown>
	);
};
